import React from 'react';
import {Link} from '@shopify/hydrogen';

//components
import Text from '../custom/Text.client';
import SanityImage from '../media/SanityImage.client';

//types
import type {SanityDocBlog} from '../../types';

//config
import sanityConfig from '../../../sanity.config';

const Blog: React.FC<SanityDocBlog & {type?: string; size?: string}> = ({
  blog_title,
  blog_categories,
  blog_description,
  blog_published_date,
  blog_tags,
  blog_thumbnail,
  blog_category,
  slug,
  type,
  size,
}) => {
  const categorySlug = blog_category?.slug?.current
  if (type === 'vertical') {
    return (
      <Link to={`/blogs/${categorySlug}/${slug.current}`}>
        <article className="grid grid-cols-3 md:grid-cols-1 gap-2 md:gap-5">
          <div className="blog__thumbnail col-span-1">
          {/* aspect-w-3 aspect-h-3 */}
            <div className="">
              <SanityImage
                dataset={sanityConfig.dataset}
                layout="responsive"
                projectId={sanityConfig.projectId}
                sizes={['50vw, 100vw']}
                src={blog_thumbnail?.asset._ref}
                className="h-full object-cover"
              />
            </div>
          </div>
          <div className="col-span-2">
            {size === 'small' ? (
              <>
                <h5 className="line-clamp-3 text-lg font-semibold">
                  {blog_title}
                </h5>
              </>
            ) : (
              <>
                <Text
                  tag="h3"
                  type="article_title"
                  className="line-clamp-4 mb-[18px]"
                >
                  {blog_title}
                </Text>
                <div className="hidden md:block">
                  <Text tag="p" type="paragraph" className="line-clamp-4">
                    {blog_description}
                  </Text>
                  {blog_description?.length > 170 && (
                    <Text tag="p" type="paragraph" className="text-hk-orange">
                      read more
                    </Text>
                  )}
                </div>
              </>
            )}
          </div>
          {/* Mobile */}
          {size !== 'small' && (
            <div className="col-span-3 md:hidden">
              <p className="line-clamp-4 text-xs font-normal leading-snug">
                {blog_description}
              </p>
              {blog_description?.length > 233 && (
                <p className="text-xs font-normal text-hk-orange">read more</p>
              )}
            </div>
          )}
        </article>
      </Link>
    );
  }
  return (
    <Link to={`/blogs/${categorySlug}/${slug.current}`}>
      <article className="grid grid-cols-3 gap-2 md:gap-5">
        <div className="blog__thumbnail col-span-1">
        {/* aspect-w-3 aspect-h-2 */}
          <div className="">
            <SanityImage
              dataset={sanityConfig.dataset}
              layout="responsive"
              projectId={sanityConfig.projectId}
              sizes={['50vw, 100vw']}
              src={blog_thumbnail?.asset._ref}
              className="h-full object-cover"
            />
          </div>
        </div>
        <div className="col-span-2">
          {size === 'small' ? (
            <>
              <h5 className="line-clamp-3 mb-2 text-lg font-semibold">
                {blog_title}
              </h5>
              <Text tag="p" type="paragraph" className="">
                on {blog_published_date}
              </Text>
            </>
          ) : (
            <>
              <Text tag="h3" type="article_title" className="mb-1 md:mb-[18px]">
                {blog_title}
              </Text>
              <Text tag="p" type="paragraph" className="md:mb-2">
                <span className="text-xs md:text-lg">
                  on {blog_published_date}
                </span>
              </Text>
              <div className="hidden md:block">
                <Text tag="p" type="paragraph" className="line-clamp-4">
                  {blog_description}
                </Text>

                {blog_description?.length > 237 && (
                  <Text tag="p" type="paragraph" className="text-hk-orange">
                    read more
                  </Text>
                )}
              </div>
            </>
          )}
        </div>
        {/* Mobile */}
        {size !== 'small' && (
          <div className="col-span-3 md:hidden">
            <p className="line-clamp-4 text-xs font-normal leading-snug">
              {blog_description}
            </p>
            {blog_description?.length > 233 && (
              <p className="text-xs font-normal text-hk-orange">read more</p>
            )}
          </div>
        )}
      </article>
    </Link>
  );
};

export default Blog;
